/* tslint:disable */
/* eslint-disable */
/**
 * K·HERO
 * K·HERO API documentation
 *
 * OpenAPI spec version: 1.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import { EnMetricDistrict } from './en-metric-district';
import { EnMetricMovement } from './en-metric-movement';
import { EnMetricSide } from './en-metric-side';
 /**
 *
 *
 * @export
 * @interface CreateRomTargetDto
 */
export interface CreateRomTargetDto {

    /**
     * @type {EnMetricDistrict}
     * @memberof CreateRomTargetDto
     */
    district: EnMetricDistrict;

    /**
     * @type {EnMetricSide}
     * @memberof CreateRomTargetDto
     */
    side: EnMetricSide;

    /**
     * @type {EnMetricMovement}
     * @memberof CreateRomTargetDto
     */
    movement: EnMetricMovement;

    /**
     * Target ROM value in degrees [-180, 180]
     *
     * @type {number}
     * @memberof CreateRomTargetDto
     */
    goalDegrees: number;
}
